import { Checkbox } from "../../Checkbox"
import { IResponsiveSpacing } from "../../../../../base/styles"
import { SelectSpacingUnit } from "./SelectSpacingUnit"
import clsx from "clsx"
import { useState } from "react"

export const EditSpacing = ({ value, title, className, onChange }: {
    title: string,
    value: IResponsiveSpacing,
    className?: string,
    onChange: (value?: IResponsiveSpacing) => void
}) => {
    const [responsive, setResponsive] = useState<boolean>();

    return <div className={clsx(className)}>
        <div className="d-flex align-items-end">
            <SelectSpacingUnit
                title={title}
                className="flex-grow-1 pe-2"
                onChange={(newValue) => { onChange({ ...value, allSizes: newValue }) }}
                value={value?.allSizes} />
            <Checkbox
                title="Responsive"
                className="fs-8 fw-semibold"
                value={responsive === true}
                onChange={setResponsive} />
        </div>

        {responsive &&
            <div className="d-flex flex-row flex-wrap mx-5 my-3">
                <SelectSpacingUnit
                    title="Small"
                    className="w-50 pe-2"
                    onChange={(newValue) => { onChange({ ...value, small: newValue }) }}
                    value={value?.small} />
                <SelectSpacingUnit
                    title="Medium"
                    className="w-50 pe-2"
                    onChange={(newValue) => { onChange({ ...value, medium: newValue }) }}
                    value={value?.medium} />
                <SelectSpacingUnit
                    title="Large"
                    className="w-50 pe-2"
                    onChange={(newValue) => { onChange({ ...value, large: newValue }) }}
                    value={value?.large} />
                <SelectSpacingUnit
                    title="Ex. Large"
                    className="w-50 pe-2"
                    onChange={(newValue) => { onChange({ ...value, xLarge: newValue }) }}
                    value={value?.xLarge} />
                <SelectSpacingUnit
                    title="Ex. Large +"
                    className="w-50 pe-2"
                    onChange={(newValue) => { onChange({ ...value, xxLarge: newValue }) }}
                    value={value?.xxLarge} />
            </div>
        }
    </div>
}